import { CreateScheduledNotificationDto, ScheduledNotificationDto, UpdateScheduledNotificationDto } from '../../sdk'
import { ScheduledNotificationsActionType, ScheduledNotificationsActionTypes } from './types'

export const getScheduledNotificationsRequest = (): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.GET_NOTIFICATIONS_REQUEST,
})

export const getScheduledNotificationsSuccess = (
  response: ScheduledNotificationDto[],
): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.GET_NOTIFICATIONS_SUCCESS,
  response,
})

export const getScheduledNotificationsFailure = (errorMsg: string): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.GET_NOTIFICATIONS_FAILURE,
  errorMsg,
})

export const createScheduledNotificationRequest = (
  data: CreateScheduledNotificationDto,
): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.CREATE_NOTIFICATION_REQUEST,
  data,
})

export const createScheduledNotificationSuccess = (): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.CREATE_NOTIFICATION_SUCCESS,
})

export const createScheduledNotificationFailure = (errorMsg: string): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.CREATE_NOTIFICATION_FAILURE,
  errorMsg,
})

export const updateScheduledNotificationRequest = (
  id: string,
  data: UpdateScheduledNotificationDto,
): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.UPDATE_NOTIFICATION_REQUEST,
  id,
  data,
})

export const updateScheduledNotificationSuccess = (): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.UPDATE_NOTIFICATION_SUCCESS,
})

export const updateScheduledNotificationFailure = (errorMsg: string): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.UPDATE_NOTIFICATION_FAILURE,
  errorMsg,
})

export const deleteScheduledNotificationRequest = (id: string): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.DELETE_NOTIFICATION_REQUEST,
  id,
})

export const deleteScheduledNotificationSuccess = (): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.DELETE_NOTIFICATION_SUCCESS,
})

export const deleteScheduledNotificationFailure = (errorMsg: string): ScheduledNotificationsActionType => ({
  type: ScheduledNotificationsActionTypes.DELETE_NOTIFICATION_FAILURE,
  errorMsg,
})
